<template>
  <div>
    跳转中......
  </div>
</template>

<script>
// } from '@/utils/base'
import { Toast } from 'vant'
// const Base64 = require('js-base64').Base64
import router from '@/router'
export default {
  components: {
    [Toast.name]: Toast
  },
  data() {
    return {
      code: undefined,
      state: undefined,
      url: undefined,
      token: undefined,
      info: undefined,
      isFirst: false
    }
  },
  created() {
    console.log('fullPath', router.history.current.fullPath)
    var backrouter = router.history.current.fullPath.replace('/jump/', 'https://store.myssi.cn/')
    console.log('backrouter', backrouter)
    window.location.href = backrouter
  }
}
</script>

